function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Chip =
/*#__PURE__*/
function () {
  _createClass(Chip, null, [{
    key: "create",
    value: function create(element, options) {
      return this.instances.get(element) || new this(element, options);
    }
  }, {
    key: "createAll",
    value: function createAll() {
      var _this = this;

      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

      var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        active: false,
        disabled: false
      };

      // Finds all instances of select on the document or within a given element and instantiates them.
      var options = _objectSpread({
        initSelector: this.strings.INIT_SELECTOR
      }, _options);

      var chips = Array.from(target.querySelectorAll(options.initSelector));
      chips.forEach(function (select) {
        return _this.create(select, options);
      });
    }
  }, {
    key: "cssClasses",
    get: function get() {
      return {
        ACTIVE: 'ray-chip--active',
        DISABLED: 'ray-chip--disabled'
      };
    }
  }, {
    key: "strings",
    get: function get() {
      return {
        INIT_SELECTOR: '.ray-chip'
      };
    }
  }]);

  function Chip(root, options) {
    var _this2 = this;

    _classCallCheck(this, Chip);

    _defineProperty(this, "onClick", function () {
      if (!_this2.state.disabled) {
        _this2.state.active = !_this2.state.active;

        _this2.assignClasses();

        _this2.emitChange();
      }
    });

    _defineProperty(this, "onSpace", function (event) {
      if (!_this2.state.disabled) {
        if (event.code === 'Space' || event.key === ' ') {
          _this2.state.active = !_this2.state.active;

          _this2.assignClasses();

          _this2.emitChange();

          event.preventDefault();
        }
      }
    });

    this._root = root;
    this._options = options;
    this.constructor.instances.set(this._root, this);
    this.state = {
      active: this._root.classList.contains(this.constructor.cssClasses.ACTIVE),
      disabled: this._root.classList.contains(this.constructor.cssClasses.DISABLED)
    };

    this._bindEventListeners();

    this.assignClasses();
  }

  _createClass(Chip, [{
    key: "_bindEventListeners",
    value: function _bindEventListeners() {
      this._root.addEventListener('mousedown', this.onClick);

      this._root.addEventListener('keydown', this.onSpace);
    }
  }, {
    key: "assignClasses",
    value: function assignClasses() {
      if (this.state.active) {
        this._root.classList.add(this.constructor.cssClasses.ACTIVE);
      } else if (this.state.disabled) {
        this._root.classList.add(this.constructor.cssClasses.DISABLED);
      } else {
        this._root.classList.remove(this.constructor.cssClasses.ACTIVE);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // Implement this method to release any resources / deregister any listeners they have
      // attached. An example of this might be deregistering a resize event from the window object.
      this._root.removeEventListener('mousedown', this.onClick);

      this.constructor.instances.delete(this._root);
    }
  }, {
    key: "emitChange",
    value: function emitChange() {
      var newEvent = document.createEvent('HTMLEvents');
      newEvent.initEvent('change', true, true);

      this._root.dispatchEvent(newEvent);
    }
  }, {
    key: "set",
    value: function set(isActive) {
      this.state.active = isActive;
      this.assignClasses();
      this.emitChange();
    }
  }, {
    key: "disable",
    value: function disable(isDisabled) {
      this.state.disabled = isDisabled;
      this.assignClasses();
      this.emitChange();
    }
  }]);

  return Chip;
}();

_defineProperty(Chip, "instances", new WeakMap());

export default Chip;